import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    cell: {
      borderBottom: 'none',
      padding: theme.spacing(0, 2, 0, 0),
    },
  };
};
